import { OUTLOOK_IN_INTRO, OUTLOOK_IN_SLUG } from '@/content/outlookInsurance'
import { outlook } from '@/content/reportBuilder'
import type { Report } from '@/content/reportBuilder'

export const report: Report = {
  // The seventeenth report with a designed page of its own, and the eighth Future
  // 2030 outlook — asked for on 2026-08-28 in the same words as the seven before it
  // (*"referans alarak ilgili sayfayı birebir tıpa tıp aynısını tasarla"*) with a
  // four-part full-page capture of the live page and all six of the images it
  // carries. See `content/outlookInsurance.ts` and `pages/OutlookInsurance.tsx`.
  ...outlook(
    OUTLOOK_IN_SLUG,
    'Insurance',
    undefined,
    'future-2030-outlook-insurance-cover',
    '21a8e497-58ff-4ed9-b0b1-8ed59c5b2f97-Digitopia-Digital-Transformation-Outlook-Insurance.pdf',
  ),
  // The hero's own two lines, joined into one paragraph — same as the sibling
  // outlook entries, and for the same reason: this page draws its hero from
  // `OUTLOOK_IN_INTRO` directly, so `body` feeds exactly one thing, the meta
  // description `prerender.tsx` takes from `body[0]`. The bold claim carries no
  // full stop on the live page, so one is supplied here rather than running the two
  // sentences together in a search result.
  body: [`${OUTLOOK_IN_INTRO.lede}. ${OUTLOOK_IN_INTRO.body}`],
  layout: 'insurance-outlook',
  // Its own words, its cover, its file and the six images its bands draw, so
  // `stillToCome` has nothing left to say about it. What is still open is
  // section-by-section on its page, and `outlookInsuranceChecks()` carries that into
  // the manifest.
  check: undefined,
}

/** Its place in the index grid — the order the imported page listed them. */
export const order = 22
